import ForResidents from "./ForResidents"

export default ForResidents